<template>
  <v-autocomplete
    :items="items"
    :loading="loading"
    item-value="id"
    item-text="name"
    v-bind="$attrs"
    chips
    :value="value"
    @input="$emit('change', $event)"
  >
    <template v-slot:item="{ item, on, attrs }">
      <v-list-item v-bind="attrs" v-on="on">
        <v-list-item-avatar>
          <UserAvatar
            :user_name="item.name"
            :size="55"
            :font_size="16"
            :avatar_url="item.avatar_url"
            :user_id="item.id"
          />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import UsersService from "@/services/UsersService";
import UserAvatar from "@/components/users/UserAvatar";

export default {
  components: { UserAvatar },
  model: {
    prop: "value",
    event: "change",
  },
  props: ["value"],
  data() {
    const service = new UsersService();
    return {
      items: [],
      service,
      loading: false,
    };
  },
  methods: {
    async getData() {
      this.loading = true;
      this.items = await this.service.index({
        list: true,
      });
      this.loading = false;
    },
  },
  created() {
    this.getData();
  },
};
</script>